import React from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { SplitValueCardProps } from "../../type";
import { BaseCard } from "./BaseCard";
import { operationsDashboardStyles } from "../../styles";

export const SplitValueCard: React.FC<SplitValueCardProps> = ({ data }) => {
  return (
    <BaseCard data={data}>
      {data.unit?.includes("%") ? (
        <Typography
          sx={operationsDashboardStyles.valueText}
        >{`${data.value}${data.unit}`}</Typography>
      ) : (
        <Box sx={operationsDashboardStyles.flexCenter}>
          <Typography sx={operationsDashboardStyles.unitText}>
            {data.unit ?? ""}
          </Typography>
          <Typography sx={operationsDashboardStyles.valueText}>
            {data.value}
          </Typography>
        </Box>
      )}
      <Divider sx={operationsDashboardStyles.divider} />
      {data.splitValues && data.splitValues.length > 0 && (
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={operationsDashboardStyles.marginTop1}
        >
          {data.splitValues.map((item, index) => (
            <Stack
              key={`${item.label}-${item.value}`}
              direction="column"
              alignItems={index === 0 ? "flex-start" : "flex-end"}
            >
              <Typography sx={operationsDashboardStyles.comparisonValue}>
                {item.value}
              </Typography>
              <Typography sx={operationsDashboardStyles.comparisonLabel}>
                {item.label}
              </Typography>
            </Stack>
          ))}
        </Stack>
      )}
    </BaseCard>
  );
};
